import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { GameLogoModel } from '../../../game/models/game-logo.model';
import { GameModel } from '../../../game/models/game.model';

import { GameService } from '../../../game/services/game.service';
import { ThemeService } from '../../../shared/theme/services/theme.service';

@Component({
  selector: 'game-logo',
  templateUrl: './game-logo.component.html',
})
export class GameLogoComponent implements OnInit, OnDestroy {

  public game: GameModel = null;
  public class: string = null;

  public gameLogo: GameLogoModel = new GameLogoModel();

  @Input() public logoSize: string = 'logo-medium';
  @Input() public guest: boolean = false;

  private theme: string = null;
  private subscription: Subscription = new Subscription();

  /**
   * Constructor
   *
   * @param {GameService} gameService
   * @param {ThemeService} themeService
   */
  public constructor(
    private gameService: GameService,
    private themeService: ThemeService,
  ) { }

  /**
   * Initialize the Component
   *
   * @return void
   */
  public ngOnInit(): void {

    this.class = this.logoSize;

    this.theme = this.themeService.theme;
    this.game = this.gameService.game;

    this.subscription.add(
      this.themeService.getThemeChange().subscribe(
        (theme: string) => {
          if (this.theme !== theme) {
            this.theme = theme;
            this.setGameLogo();
          }
        },
      ),
    );

    if (this.guest) {
      this.theme = this.themeService.theme;
      this.setThemeLogo();
    } else {
      this.setGameLogo();
    }
  }

  /**
   * When the component is destroyed
   *
   * @return void
   */
  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * set the GameLogo
   *
   * @return void
   */
  private setGameLogo(): void {
    if (this.game.game_logo !== null) {
      this.gameLogo = this.game.game_logo;
    } else {
      this.setThemeLogo();
    }
  }

  /**
   * Set the theme logo
   *
   * @return void
   */
  private setThemeLogo(): void {

    let path: string = '';

    if (environment.production) {
      path = this.themeService.assetsDir + this.theme + '/desktop/images/general/';
    } else {
      path = 'assets/themes/' + environment.theme + '/desktop/images/general/';
    }

    this.gameLogo.normal_url = path + 'normal/' + this.logoSize + '.png';
    this.gameLogo.retina_url = path + 'retina/' + this.logoSize + '@2x.png';
  }
}
